const REACT_QUERY_KEY_VALUE_PAIRS = {
    accessControls: 'accessControls',
    accessGroups: 'accessGroups',
    allAccessControls: 'allAccessControls',
    allNoiseDevices: 'allNoiseDevices',
    allProcessAndSchemas: 'allProcessAndSchemas',
    allProcessAndVariableLookups: 'allProcessAndVariableLookups',
    allProcessLookups: 'allProcessLookups',
    allProcesses: 'allProcesses',
    alertById: 'alertById',
    alertOutputs: 'alertOutputs',
    alertResponseCategories: 'alertResponseCategories',
    arrayProfileLookup: 'arrayProfileLookup',
    categoryTypes: 'categoryTypes',
    calmetConfigurations: 'calmetConfigurations',
    calpuffConfigurations: 'calpuffConfigurations',
    classificationTypes: 'classificationTypes',
    companyFacilities: 'companyFacilities',
    convertBaseValuesToDisplayValues: 'convertBaseValuesToDisplayValues',
    cronDescription: 'cronDescription',
    dataImporter: 'dataImporter',
    dataImporterExecutionLogs: 'dataImporterExecutionLogs',
    dataImporterTemplates: 'dataImporterTemplates',
    dataImportersWithSteps: 'dataImportersWithSteps',
    displayUnits: 'displayUnits',
    emailRecipients: 'emailRecipients',
    elevationByLatLon: 'elevationByLatLon',
    emissionSourceDetails: 'emissionSourceDetails',
    emissionSources: 'emissionSources',
    esObjectProbeById: 'esObjectProbeById',
    evaluateProcessVariableFormula: 'evaluateProcessVariableFormula',
    facilityDetails: 'facilityDetails',
    facilityLocation: 'facilityLocation',
    facilityLocations: 'facilityLocations',
    facilityTimezone: 'facilityTimezone',
    facilityUsers: 'facilityUsers',
    featureFlags: 'featureFlags',
    fileSystemObject: 'fileSystemObject',
    fileSystemObjects: 'fileSystemObjects',
    kunakDataImporter: 'kunakDataImporter',
    kunakDataImporterSequences: 'kunakDataImporterSequences',
    kunakDataImporterSequencesToUpdate: 'kunakDataImporterSequencesToUpdate',
    kunakDataImporters: 'kunakDataImporters',
    kunakDeviceDetails: 'kunakDeviceDetails',
    kunakDeviceElements: 'kunakDeviceElements',
    kunakDevices: 'kunakDevices',
    kunakLocationProcesses: 'kunakLocationProcesses',
    kunakProcess: 'kunakProcess',
    kunakProcessVariables: 'kunakProcessVariables',
    kunakProcesses: 'kunakProcesses',
    kunakUnits: 'kunakUnits',
    lookupLocales: 'lookupLocales',
    lookupProcessVariableDataTypes: 'lookupProcessVariableDataTypes',
    lookupTimeZones: 'lookupTimeZones',
    machineLearningProcessSchemaHistory: 'machineLearningProcessSchemaHistory',
    modelConfigurations: 'modelConfigurations',
    monitorLocationDetails: 'monitorLocationDetails',
    monitorLocationsSummary: 'monitorLocationsSummary',
    noiseClassifierModelClassifications: 'noiseClassifierModelClassifications',
    noiseClassifierModelFull: 'noiseClassifierModelFull',
    noiseClassifierModels: 'noiseClassifierModels',
    noiseClassifierModelsSummary: 'noiseClassifierModelsSummary',
    noiseClassifierProcessSchemaHistoryDetail: 'noiseClassifierProcessSchemaHistoryDetail',
    parentVariableTreeData: 'parentVariableTreeData',
    people: 'people',
    personDetails: 'personDetails',
    pollutants: 'pollutants',
    pollutantsFull: 'pollutantsFull',
    pollutantsSummary: 'pollutantsSummary',
    processAndVariableLookups: 'processAndVariableLookups',
    processDataViewerScanSpotDate: 'processDataViewerScanSpotDate',
    processSchemaByProcessId: 'processSchemaByProcessId',
    processSchemaBySchemaId: 'processSchemaBySchemaId',
    processVariableWithInfo: 'processVariableWithInfo',
    processVariablesForProcessOrVariable: 'processVariablesForProcessOrVariable',
    processVariablesForVariableId: 'processVariablesForVariableId',
    referenceSummary: 'referenceSummary',
    reportAliasValidation: 'reportAliasValidation',
    reportCronValidation: 'reportCronValidation',
    reportDefinition: 'reportDefinition',
    reportDefinitionSummary: 'reportDefinitionSummary',
    reportDefinitionSummaries: 'reportDefinitionSummaries',
    reportSchedule: 'reportSchedule',
    reportDefinitionExecutionLogs: 'reportDefinitionExecutionLogs',
    reportDefinitionScheduleExecutionLogs: 'reportDefinitionScheduleExecutionLogs',
    reportSchedulesSummaries: 'reportSchedulesSummaries',
    reportTypeConfigurations: 'reportTypeConfigurations',
    scriptedAlertConfiguration: 'scriptedAlertConfiguration',
    scriptedAlertConfigurationMapped: 'scriptedAlertConfigurationMapped',
    scriptedAlertExecutionLogs: 'scriptedAlertExecutionLogs',
    scriptedAlerts: 'scriptedAlerts',
    sequence: 'sequence',
    sequences: 'sequences',
    sequenceExecutionLog: 'sequenceExecutionLog',
    sequenceLogs: 'sequenceLogs',
    temporalThresholds: 'temporalThresholds',
    trajectoryConfigurations: 'trajectoryConfigurations',
    unitsFull: 'unitsFull',
    unitsSummary: 'unitsSummary',
    unknownUserTemplate: 'unknownUserTemplate',
    unknownUserTemplates: 'unknownUserTemplates',
    userAccessControlOverrides: 'userAccessControlOverrides',
    validateProcessVariableFormula: 'validateProcessVariableFormula',
    variableDataByVariableIds: 'variableDataByVariableIds',
    variableForProcessLookups: 'variableForProcessLookups',
    variablesForProcess: 'variablesForProcess',
    wrfModelConfigurations: 'wrfModelConfigurations',
} as const;

const REACT_QUERY_KEY_VALUES = Object.values(REACT_QUERY_KEY_VALUE_PAIRS);

type ReactQueryKeys = (typeof REACT_QUERY_KEY_VALUES)[number];

export const QUERY_KEY: { [Key in ReactQueryKeys]: Key } = {
    ...REACT_QUERY_KEY_VALUE_PAIRS,
};
